module.exports = __webpack_public_path__ + "static/media/logo.d36e8405.png";